import request from '@/router/axios';
import dictionary from "@/assets/js/dictionary";


const getUniqNo = function (dictName, arr) {
  return arr[dictName] ? arr[dictName].uniqNo : false;
};

export const getSysOption = (dictName) => {
  //系统字典
  let uniqNo = getUniqNo(dictName, dictionary.sys_dict);
  if (!uniqNo) {
    return;
  }
  return request({
    url: "/api/blade-system/v1.0/dict/select",
    method: "get",
    params: {
      uniqNo: uniqNo,
    },
  });
};

export const getBusOptionTree = (dictName) => {
  //获取字典树
  let uniqNo = getUniqNo(dictName, dictionary.bus_dict);
  if (!uniqNo) {
    return;
  }
  return request({
    url: "/api/blade-system/v1.0/dict-biz/select-tree",
    method: "get",
    params: {
      uniqNo: uniqNo,
    },
  });
};


export const getBusoption = (dictname) => {
  //业务字典
  let uniqNo = getUniqNo(dictname, dictionary.bus_dict)
  if (!uniqNo) {
    return
}

return request({
    url: '/api/blade-system/v1.0/dict-biz/select-list',
    method: 'get',
    params: {
      uniqNo: uniqNo
    }
  })
}


//企微应用助手菜单数据
export const getWecomAgentRoutes = (data) => {
  return request({
    url: '/api/blade-system/menu/wecom-agent-routes',
    method: 'post',
    data: data
  });
};
